/**
 * Was im Filterpanel ein- und ausschaltbar ist.
 * `layers` sind Layer-IDs aus buildStyle(); `children` erzeugt Unterfilter.
 */
export const LAYER_GROUPS = [
  {
    id: 'relief',
    label: 'Reliefschattierung',
    // Die Vektorquelle reicht von 3.57 bis 13.66 Ost und 44.18 bis 48.88 Nord,
    // also ueber die Landesgrenze hinaus - "nur Schweiz" stimmte nicht mehr.
    note: 'swisstopo, Alpenraum',
    layers: ['relief-welt', 'relief-raster', 'relief-global', 'relief-hachure'],
    default: true
  },
  {
    id: 'contours',
    label: 'Höhenlinien',
    note: 'swisstopo',
    layers: ['contour-minor', 'contour-main', 'contour-eis', 'contour-welt-main', 'contour-welt-minor', 'contour-label', 'contour-welt-label', 'spot-elevation'],
    default: true,
    children: [
      { id: 'contour-main-g', label: 'Hauptkurven', layers: ['contour-main', 'contour-welt-main', 'contour-eis'], swatch: '#A8703C', default: true },
      { id: 'contour-minor-g', label: 'Zwischenkurven', layers: ['contour-minor', 'contour-welt-minor'], swatch: '#C79A6B', default: true },
      { id: 'contour-label-g', label: 'Höhenangaben', layers: ['contour-label', 'contour-welt-label'], default: true },
      { id: 'spot-elevation-g', label: 'Höhenkoten', layers: ['spot-elevation'], default: true }
    ]
  },
  {
    id: 'vegetation',
    label: 'Wald & Vegetation',
    layers: ['lc-forest', 'lc-forest-edge', 'lc-scrub', 'lc-grass', 'lc-park'],
    default: true
  },
  {
    id: 'trees',
    label: 'Einzelbäume',
    note: 'ab Zoom 15',
    layers: ['tree-single', 'tree-row'],
    default: true
  },
  {
    id: 'surface',
    label: 'Bodenbedeckung',
    note: 'Siedlung, Kulturland, Fels, Gletscher',
    layers: ['lc-settlement', 'lc-farmland', 'lc-rock', 'lc-sand', 'lc-glacier'],
    default: true
  },
  {
    id: 'water',
    label: 'Gewässer',
    layers: ['water-fill', 'water-edge', 'water-river', 'water-stream', 'water-ferry',
             'label-water', 'label-waterway', 'label-stream'],
    default: true,
    children: [
      { id: 'water-lakes', label: 'Seen & Flächen', layers: ['water-fill', 'water-edge'], default: true },
      { id: 'water-rivers', label: 'Flüsse & Kanäle', layers: ['water-river'], default: true },
      { id: 'water-streams', label: 'Bäche', layers: ['water-stream', 'label-stream'], default: true },
      { id: 'water-ferry-g', label: 'Schiffsrouten', layers: ['water-ferry'], default: true }
    ]
  },
  {
    id: 'roads',
    label: 'Strassen',
    layers: [
      'road-motorway', 'road-motorway-case', 'road-trunk', 'road-trunk-case',
      'road-primary', 'road-primary-case', 'road-secondary', 'road-secondary-case',
      'road-tertiary', 'road-tertiary-case', 'road-minor', 'road-minor-case',
      'road-service', 'road-service-case', 'road-tunnel', 'label-road'
    ],
    default: true,
    children: [
      { id: 'road-motorway-g', label: 'Autobahn', layers: ['road-motorway', 'road-motorway-case'], swatch: '#F2D54E', default: true },
      { id: 'road-trunk-g', label: 'Autostrasse', layers: ['road-trunk', 'road-trunk-case'], swatch: '#E89A7E', default: true },
      { id: 'road-primary-g', label: 'Hauptstrasse', layers: ['road-primary', 'road-primary-case'], swatch: '#E89A7E', default: true },
      { id: 'road-secondary-g', label: 'Nebenstrasse', layers: ['road-secondary', 'road-secondary-case'], swatch: '#F8D86A', default: true },
      { id: 'road-tertiary-g', label: 'Verbindungsstrasse', layers: ['road-tertiary', 'road-tertiary-case'], swatch: '#FFFFFF', default: true },
      { id: 'road-minor-g', label: 'Quartierstrasse', layers: ['road-minor', 'road-minor-case'], swatch: '#FFFFFF', default: true },
      { id: 'road-service-g', label: 'Zufahrt / Service', layers: ['road-service', 'road-service-case'], swatch: '#F0ECE3', default: true },
      { id: 'road-tunnel-g', label: 'Tunnel', layers: ['road-tunnel'], default: true }
    ]
  },
  {
    id: 'paths',
    label: 'Wege & Pfade',
    layers: ['road-track', 'road-path', 'path-hiking'],
    default: true,
    children: [
      { id: 'paths-hiking', label: 'Wanderwege', layers: ['path-hiking'], swatch: '#2A2724', default: true },
      { id: 'paths-track', label: 'Feld- & Waldwege', layers: ['road-track'], swatch: '#4A463E', default: true },
      { id: 'paths-foot', label: 'Trottoirs, Treppen, Velowege', layers: ['road-path'], swatch: '#6B655A', default: true }
    ]
  },
  {
    // Velo: eine Auflage, keine Kartenebene der Landeskarte - deshalb
    // standardmässig aus. Die beiden Netze kommen vom Bund und zeigen die
    // *signalisierten* Routen; die Velowege darunter kommen aus OSM und zeigen
    // die Infrastruktur, die vor der Haustür liegt.
    id: 'velo',
    label: 'Velo',
    note: 'ASTRA / SchweizMobil',
    layers: ['velo-netz', 'velo-mtb', 'velo-sperren', 'velo-weg', 'velo-schieben', 'velo-unbefestigt'],
    // Eine Gruppe leitet ihren Zustand aus den Kindern ab - alle aus heisst
    // Gruppe aus. `kern` sagt, was ein Klick auf "Velo" anschaltet: das Netz
    // des Bundes und die Velowege aus OSM, nicht gleich alle sechs.
    default: false,
    kern: ['velo-netz-g', 'velo-weg-g'],
    children: [
      { id: 'velo-netz-g', label: 'Veloland Schweiz', note: 'signalisiert, ab Zoom 11', layers: ['velo-netz'], swatch: '#0099FF', default: false },
      { id: 'velo-mtb-g', label: 'Mountainbikeland', layers: ['velo-mtb'], swatch: '#0032FD', default: false },
      { id: 'velo-sperren-g', label: 'Sperrungen & Umleitungen', layers: ['velo-sperren'], default: false },
      { id: 'velo-weg-g', label: 'Velowege', note: 'aus OSM', layers: ['velo-weg'], swatch: '#0A7E8C', default: false },
      { id: 'velo-schieben-g', label: 'Absteigen nötig', layers: ['velo-schieben'], swatch: '#0A7E8C', default: false },
      { id: 'velo-unbefestigt-g', label: 'Unbefestigt', layers: ['velo-unbefestigt'], swatch: '#9A6A2E', default: false }
    ]
  },
  {
    id: 'rail',
    label: 'Bahn & ÖV-Trassee',
    layers: ['rail-base', 'rail-service', 'rail-tunnel', 'rail-light'],
    default: true
  },
  {
    id: 'buildings',
    label: 'Gebäude',
    layers: ['building-fill', 'building-edge'],
    default: true
  },
  {
    id: 'aeroway',
    label: 'Flugplätze',
    layers: ['aeroway-area'],
    default: true
  },
  {
    id: 'boundaries',
    label: 'Grenzen',
    layers: ['boundary-country-band', 'boundary-country', 'boundary-canton-band', 'boundary-canton'],
    default: true,
    children: [
      { id: 'boundary-country-g', label: 'Landesgrenze', layers: ['boundary-country-band', 'boundary-country'], default: true },
      { id: 'boundary-canton-g', label: 'Kantonsgrenze', layers: ['boundary-canton-band', 'boundary-canton'], default: true }
    ]
  },
  {
    id: 'labels',
    label: 'Beschriftung',
    layers: ['label-place-city', 'label-place-town', 'label-place-small', 'label-country', 'label-peak', 'label-area-name', 'label-housenumber', 'label-motorway'],
    default: true,
    // Beim Einschalten der Gruppe nicht auch die Flurnamen - siehe unten.
    kern: ['labels-places', 'labels-peaks', 'labels-housenumbers'],
    children: [
      { id: 'labels-places', label: 'Orte', layers: ['label-place-city', 'label-place-town', 'label-place-small', 'label-country'], default: true },
      // Aus, weil Mundart: swisstopo fuehrt die Lokalnamen amtlich so, wie man
      // sie vor Ort spricht ("Chrüzmatt", "Chlistadt"), und eine schriftdeutsche
      // Fassung gibt es dazu nicht. Neue Kennung statt `labels-areas`: eine
      // gespeicherte Einstellung nennt die alte mit `true` und setzte die Ebene
      // sonst bei allen wieder ein, die schon einmal gefiltert haben.
      { id: 'labels-flurnamen', label: 'Flurnamen', note: 'amtlich, oft Mundart', layers: ['label-area-name'], default: false },
      { id: 'labels-peaks', label: 'Gipfel & Höhen', layers: ['label-peak'], default: true },
      { id: 'labels-housenumbers', label: 'Hausnummern', layers: ['label-housenumber'], default: true }
    ]
  },
  {
    id: 'poi',
    label: 'Punkte von Interesse',
    layers: ['poi-symbol', 'poi-minor'],
    default: true
  }
];

export function flattenGroups() {
  const out = [];
  for (const g of LAYER_GROUPS) {
    out.push(g);
    if (g.children) out.push(...g.children);
  }
  return out;
}
